var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"field-wrapper"},[_c('input',{class:[
      'radio-btn-input',
      _vm.isSelected ? 'selected' : '',
      _vm.isDisabled ? 'disabled' : ''
    ],attrs:{"id":_vm.radioBtnLabel,"type":"radio","label":_vm.radioBtnLabel,"disabled":_vm.isDisabled},domProps:{"value":_vm.radioBtnValue,"checked":_vm.isSelected},on:{"change":function($event){_vm.$emit('change', _vm.radioBtnValue.toLowerCase())}}}),_c('label',{staticClass:"label",class:[_vm.isDisabled ? 'disabled' : ''],attrs:{"for":_vm.radioBtnLabel}},[_vm._v(_vm._s(_vm.radioBtnLabel))])])
}
var staticRenderFns = []

export { render, staticRenderFns }